// extracted by mini-css-extract-plugin
export default {"container":"PunchupBuyerSeatsWidget_container__da8hC"};